<div>
  <div class="md-title">
    <ng-container *ngIf="!state">
      {{ 'record_audio.push_the_button' | translate }}
    </ng-container>

    <ng-container *ngIf="state === 'recording'">
      {{ 'record_audio.push_the_button_to_stop' | translate }}
    </ng-container>

    <ng-container *ngIf="state === 'finished'">
      {{ 'record_audio.your_recording' | translate }}
    </ng-container>
  </div>

  <div *ngIf="maxTime" class="md-subhead">
    {{ 'record_audio.max_duration' | translate: { maxTime: maxTime / 60 } }}
  </div>

  <div *ngIf="maxRecord === 1" class="md-subhead">
    {{ 'record_audio.only_one_try' | translate }}
  </div>

  <div
    *ngIf="!state || state === 'recording'"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <div *ngIf="canRecord">
      <button *ngIf="!state" class="r notRec" (click)="play()" type="button">
        {{ 'record_audio.record' | translate }}
      </button>

      <button
        *ngIf="state === 'recording'"
        class="r Rec"
        (click)="stop()"
        type="button"
      >
        {{ 'record_audio.stop_recording' | translate }}
      </button>
    </div>

    <div *ngIf="!canRecord">
      <br />
      {{ 'record_audio.no_more_try' | translate }}
      <br />
      <br />
    </div>

    <div *ngIf="state === 'recording'">
      <span *ngIf="maxTime">
        <polylearn-timer
          (onTimerUpdate)="onTimerUpdate($event)"
          [started]="true"
          [counter]="maxTime"
        ></polylearn-timer>
      </span>
    </div>
  </div>

  <div *ngIf="state === 'finished'">
    <br />
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <audio [src]="audio.audioUrl | safe: 'resourceUrl'" controls>
        Your browser does not support the
        <code>audio</code> element.
      </audio>

      <button
        mat-stroked-button
        type="button"
        *ngIf="
          canCancel &&
          canRecord &&
          state === 'finished' &&
          numberOfRecord !== maxRecord
        "
        (click)="state = null; recorded.emit(null)"
      >
        {{ 'record_audio.cancel_recording' | translate }}
      </button>

      <!--
         <button type="button" (click)="uploadFile(audio.audioBlob)">
           Upload
         </button>
       -->
    </div>
    <br />
  </div>
</div>

<!--
   <button *ngIf="state === 'finished'" (click)="playAudio()">
   Play audio
   </button>
 -->
